module.exports = __webpack_public_path__ + "img/beer_id-83.dbce2433.png";